export default __webpack_public_path__ + "static/media/1.23b671e9.jpg";